import {
    CLEAR_API_KEY_TOKEN,

    DELETE_API_KEY,
    DELETE_API_KEY_FAILURE,
    DELETE_API_KEY_SUCCESS,
} from 'store/actions/types';

export const clearApiKeyToken = () => {
    return {
        type: CLEAR_API_KEY_TOKEN,
    };
};

export const deleteApiKey = (payload) => {
    return {
        type: DELETE_API_KEY,
        payload: payload,
    };
};

export const deleteApiKeyFailure = (error) => {
    return {
        type: DELETE_API_KEY_FAILURE,
        error: error,
    };
};

export const deleteApiKeySuccess = (payload) => {
    return {
        type: DELETE_API_KEY_SUCCESS,
        payload: payload,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/apiKeys/deleteApiKeys.js